var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 58.391C11 49.5595 12.8928 47.6667 21.7243 47.6667H66.2757C75.1073 47.6667 77 49.5595 77 58.391V66.2758C77 75.1073 75.1073 77.0001 66.2757 77.0001H21.7243C12.8928 77.0001 11 75.1073 11 66.2758V58.391Z",
    stroke: "#323232",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 47.6667V42.7387C22 34.7189 23.7189 33 31.7387 33H56.2613C64.2811 33 66 34.7189 66 42.7387V47.6667",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.0001V25.6667",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 12.8333V11",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 33.0001V25.6667",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12.8333V11",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33.0001V25.6667",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12.8333V11",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 58.8123C12.134 58.7115 13.3411 58.6667 14.6667 58.6667C20.5706 58.6667 23.4294 62.3334 29.3333 62.3334C35.2373 62.3334 38.0959 58.6667 44 58.6667C49.9041 58.6667 52.7626 62.3334 58.6667 62.3334C64.5707 62.3334 67.4293 58.6667 73.3333 58.6667C74.6588 58.6667 75.8659 58.7115 77 58.8123",
    stroke: "#323232",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.91a4582c18c9268c8946129980c4f436.svg";
export { ForwardRef as ReactComponent };